module.exports = __webpack_public_path__ + "img/img-6.d4279514.svg";